import React from 'react';
import camelCase from 'lodash.camelcase';
import Responses from './Responses';

const Question = props => {
  return (
    <div>
      <br />
      <strong>{props.description}</strong>
      <Responses
        type={camelCase(props.inputType)}
        value={props.value}
        error={props.error}
        onChange={props.onChange}
        onBlur={props.onBlur}
        options={props.options}
        color={props.color}
      />
    </div>
  );
};

export default Question;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/Question.js